/**
 * Caricamento CSV per la rendicontazione costi personale — sezione separata
 * dall'analisi (CostoPersonalePage, /costo-personale) per non mescolare
 * l'operazione di scrittura (solo admin lato backend) con la consultazione
 * di sola lettura del report. Il pannello effettivo (upload + storico
 * caricamenti) resta in pages/costoPersonale/ImportPanel.jsx, riusato qui.
 */
import React from "react";
import { Link } from "react-router-dom";
import ImportPanel from "./costoPersonale/ImportPanel";

export default function CostoPersonaleImportPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-xl font-bold text-gray-900">
            Import costo personale
          </h1>
          <p className="text-sm text-gray-500">
            Caricamento periodico dei export CSV dal gestionale presenze
            (anagrafica dipendenti + costi mensili).
          </p>
        </div>
        <Link
          to="/costo-personale"
          className="shrink-0 px-3 py-1.5 text-sm rounded border border-gray-300 text-gray-700 hover:bg-gray-50"
        >
          ← Vai all'analisi
        </Link>
      </div>

      <ImportPanel />
    </div>
  );
}
